import { render } from "./pending-visits.vue?vue&type=template&id=0bad3af0&ts=true"
import script from "./pending-visits.vue?vue&type=script&lang=ts"
export * from "./pending-visits.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__